import { Box, Typography } from '@mui/material';
import * as React from "react";
import { Autoplay, EffectFade } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import Fluid from 'components/Fluid'
import Link from 'components/Link'
import { ReactComponent as ArrowUpRight } from 'images/icons/arrow_up_right.svg';

import 'swiper/css';
import 'swiper/css/effect-fade';

const VerticalTextThreeSlides = ({slides, title, flush, background, backgroundImage, backgroundProps, padding, ...props}) => {

	const slideRef = React.useRef(null);
	const [slideWidth, setSlideWidth] = React.useState('100%');
	const showLabels = Array.isArray(slides) && slides.length > 0 && slides.every((slide) => (
		typeof slide === 'object' && slide !== null &&
		Object.hasOwn(slide, 'label') && slide.label && slide.label !== null && slide.label !== ''
	));

	const sectionInlineStyle = {
		...(backgroundImage ? {
			backgroundImage: `url("${process.env.CDN_DOMAIN||''}${backgroundImage}?max-w=1920&format=webp&quality=70")`,
			...(backgroundProps ? {
				...(backgroundProps.indexOf('cover') !== -1 ? {
					backgroundSize: 'cover',
				} : null),
				...(backgroundProps.indexOf('fixed') !== -1 ? {
					backgroundAttachment: 'fixed',
				} : null),
				...(backgroundProps.indexOf('repeat') !== -1 ? {
					backgroundRepeat: 'repeat',
				} : {backgroundRepeat: 'no-repeat'}),
			} : null),
		} : null),
	}

	React.useEffect(() => {	
		const slideElement = slideRef.current;
		if (!slideElement) return;

		const updateSlideWidth = () => {
			const nextWidth = slideElement.getBoundingClientRect().height;
			setSlideWidth((currentWidth) => currentWidth === nextWidth ? currentWidth : nextWidth);
		};

		updateSlideWidth();
		if (typeof ResizeObserver === 'undefined') {
			window.addEventListener('resize', updateSlideWidth);
			return () => window.removeEventListener('resize', updateSlideWidth);
		}

		const resizeObserver = new ResizeObserver(updateSlideWidth);
		resizeObserver.observe(slideElement);
		return () => resizeObserver.disconnect();
	}, [slides]);

	if (!slides || typeof slides !== 'object' || slides === null || slides.length === 0) {
		return null;
	}

	return (
		<Box
			sx={(Object.keys(sectionInlineStyle).length > 0 ? sectionInlineStyle : null)}
			className={[
				'verticalTextThreeSlides__section', 
				(padding ? 'padding-normal' : ''), 
				(flush ? 'margin-flush' : ''),
				(background||'')
			].join(' ')}
		>
			<Fluid layout='12' className="verticalTextThreeSlides__grid">
				<Box className="verticalTextThreeSlides__grid_inner">
					<Swiper
						modules={[Autoplay, EffectFade]}
						slidesPerView={1}
			      		autoplay={{ 
			      			delay: 3000,
			      			pauseOnMouseEnter: true,
			      		}}
			      		effect={'fade'}
			      		fadeEffect={{
			      			crossFade: true
			      		}}
			      		loop={true}
			      		className={'verticalTextThreeSlides__wrapper'}
			      		speed={500}
					>
						{slides.length && slides.map((slide,index) => {
							let inlineStyle = {};
							if (slide?.image) {
								inlineStyle.backgroundImage = `url("${slide.image}?max-w=1920&format=webp&quality=70")`;
							}
							if (title && slide?.title && slide?.image) {
								inlineStyle.backgroundImage = `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.45) 100%), ${inlineStyle.backgroundImage}`;
							}
							const SlideWrapper = slide?.link ? Link : Box;
							const slideLinkProps = slide?.link ? {
								href: slide.link,
								underline: 'none',
								'aria-label': slide?.title || slide?.label || `Slide ${index + 1}`,
							} : {};
							return (
								<SwiperSlide key={index} className="verticalTextThreeSlides__slide">
									<SlideWrapper
										{...slideLinkProps}
										className={[
											"verticalTextThreeSlides__slide_inner",
											slide?.link ? "verticalTextThreeSlides__slide_link" : "",
											!showLabels ? 'hideLabels' : '',
										].filter(Boolean).join(' ')}
									>
										<Box ref={index === 0 ? slideRef : undefined} sx={((Object.keys(inlineStyle).length > 0) ? inlineStyle : undefined)}
											className={`verticalTextThreeSlides__slide_title_wrapper`}
										>
											{title && slide?.title && <Typography component="div" className="verticalTextThreeSlides__slide_title_wrapper__title">{slide.title}</Typography>}
											{slide?.link && <div className={`verticalTextThreeSlides__link_holder ${!showLabels ? 'hideLabels' : ''}`}>
												<span className="verticalTextThreeSlides__link" aria-hidden="true"><ArrowUpRight /></span>
											</div>}
										</Box>
										{showLabels && (
										<Box 
											sx={{
												width: slideWidth,
											}}
											className={`verticalTextThreeSlides__vertical_text_wrapper slide_${index+1}`}
										>
											<Typography component="div" className={`verticalTextThreeSlides__vertical_text_wrapper_label`}>{slide?.label}</Typography>
										</Box>
										)}
									</SlideWrapper>
								</SwiperSlide>
							)
						})}
					</Swiper>
					<Box className={`verticalTextThreeSlides__title_wrapper ${!showLabels ? 'hideLabels' : ''}`}>
						{title && <Typography component="div" className="verticalTextThreeSlides__title_wrapper__title">{title}</Typography>}
					</Box>
				</Box>
			</Fluid>
		</Box>
	)
}

export default React.memo(VerticalTextThreeSlides);